import { toDuration } from '@rtls/core/util/date-util';
import * as Factory from 'factory.ts';
import { stopFactory } from './stop.factory';
import { StopTime } from './stopTime.model';

export const stopTimeFactory = Factory.makeFactory<StopTime>({
	arrivalTime: Factory.each((i) => toDuration((i + 1) * (i + 2) * 1000000).toISO()),
	departureTime: Factory.each((i) => toDuration((i + 1) * (i + 3) * 1000000).toISO()),
	stop: Factory.each(() => stopFactory.build()),
	stopSequence: Factory.each((i) => i),
});
